import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import AOS from "aos";
import "aos/dist/aos.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useAuth } from "../Auth/AuthContext";
import AccountDetailApiService from "../../ApiServices/SettingApiServices/AccountDetailApiService";

// Set custom styles for the modal
const customStyles = {
    content: {
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        padding: "0",
        borderRadius: "8px",
        boxShadow: "0 8px 30px rgba(0, 0, 0, 0.2)",
        backgroundColor: "#f9f9f9",
        width: "500px",
    },
};

const AddAccountDetailForm = ({ isOpen, closeModal }) => {
    const [formData, setFormData] = useState({
        FirstName: "",
        LastName: "",
        Company: "",
        PhoneNumber: "",
    });
    const [loading, setLoading] = useState(false);

    const Auth = useAuth();
    const user = Auth.authState.user;

    // Fetch data when modal opens
    useEffect(() => {
       
            AOS.init({ duration: 1000, once: true });
            fetchData();
        
    }, []);

    // Fetch data from API
    const fetchData = async () => {
        try {
            setLoading(true);
            const UserId = user?.id;

            if (!UserId) {
                throw new Error("User ID is undefined");
            }

            const settingData = await AccountDetailApiService.Get(UserId);


            setFormData({
                FirstName: settingData.data.firstName || "",
                LastName: settingData.data.lastName || "",
                Company: settingData.data.company || "",
                PhoneNumber: settingData.data.phoneNumber || "",
            });
        } catch (error) {
            console.error("Error fetching data:", error);
            toast.error("Failed to load user details.");
        } finally {
            setLoading(false);
        }
    };

    // Handle input changes
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevFormData) => ({
            ...prevFormData,
            [name]: value,
        }));
    };

    // Submit data
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const UserId = user?.id;

        try {
            const accountDetailData = {
                ...formData,
                Id: UserId, // Replace with dynamic Id if required
            };

            const result = await AccountDetailApiService.Update(accountDetailData);
            toast.success(result.message);
            // closeModal(); // Close modal after successful submission
        } catch (error) {
            console.error("Error updating data:", error);
            toast.error("Failed to update user details.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <ToastContainer />

            {/* Modal Container */}
            {/* <Modal
                isOpen={isOpen}
                onRequestClose={closeModal}
                style={customStyles}
                ariaHideApp={false}
            > */}
                <div className="bg-white p-6 rounded-lg shadow-md mb-6" data-aos="fade-up">
                    <h2 className="text-xl font-semibold mb-4">User Detail</h2>
                    <form onSubmit={handleSubmit} className="space-y-4">
                        {/* Input Fields */}
                        {["FirstName", "LastName", "Company", "PhoneNumber"].map((field) => (
                            <div key={field} className="flex flex-col">
                                <label htmlFor={field} className="text-gray-600 mb-1">
                                    {field}
                                </label>
                                <input
                                    type="text"
                                    id={field}
                                    name={field}
                                    value={formData[field]}
                                    onChange={handleInputChange}
                                    className="border border-gray-300 rounded-md p-2 focus:outline-none focus:border-blue-500"
                                    placeholder={`Enter ${field}`}
                                    disabled={loading} // Disable during loading
                                />
                            </div>
                        ))}

                        {/* Buttons */}
                        <div className="flex justify-left space-x-3 mt-6">
                            <button
                                type="submit"
                                className="px-4 py-2 bg-blue-600 text-white rounded-md shadow-md hover:bg-blue-700 transition duration-200"
                                 disabled={loading}
                            >
                                {/* Save Changes */}
                                {loading ? "Saving..." : "Save Changes"}
                            </button>
                            {/* <button
                                type="button"
                                onClick={closeModal}
                                className="px-4 py-2 bg-gray-300 text-gray-800 rounded-md shadow-md hover:bg-gray-400 transition duration-200"
                                // disabled={loading}
                            >
                                Close
                            </button> */}
                        </div>
                    </form>
                </div>
            {/* </Modal> */}
        </>
    );
};

export default AddAccountDetailForm;
